<template>
    <dx-check-box
        class="m-3"
        :value="importedRef"
        @value-changed="onValueChange"
        text="Показывать импортированные строки справочника"
    ></dx-check-box>
    <ai-grid-edit-wrapper
        :action="getInstance"
        @user-data-changed="onUserDataChanged"
        @refresh="onRefreshHandler"
        @changesRemoved="onChangesRemoved"
        @userDataChangedLoaded="onUserDataChangedLoaded"
        :args="args"
        :meta="meta"
        ref="gridRef"
        @gridEditWrapperMounted="onEditGridMounted"
    />
</template>

<script>
export default {
    name: 'typetrans-view',
};
</script>

<script setup>
import { DxCheckBox } from 'devextreme-vue/check-box';
import { meta } from './meta';
import { reactive, ref, watch } from 'vue';
import {
    setIsDirtyValue,
    setTabReadyToSaveValue,
    tabState,
} from '@/layouts/main-layout/components/navigation-bars-data';
import { saveUserDataChanges } from '@/service/userdata-service';
import { setViewData, setActiveViewInfo } from '@/layouts/main-layout/main-layout-data';

const importedRef = ref(false);
const gridRef = ref();
const isDirty = ref(false);
const typeTransInstance = ref();
let saveFunc;
let prepareChanges;
let setDataSource;

const args = reactive({
    select: {
        select_args: {
            selectArg: importedRef.value,
        },
    },
});

const onEditGridMounted = async () => {
    typeTransInstance.value = {
        refresh: setDataSource,
        userData: gridRef.value.setUserDataFromCacheOrApi,
        userSettings: gridRef.value.fetchAndSetUserSettings,
    };
    setActiveViewInfo(typeTransInstance.value);

    await setViewData();

    setTabReadyToSaveValue(true);
};

const getInstance = inst => {
    saveFunc = inst.save;
    setDataSource = inst.setDataSource;
    prepareChanges = inst.componentRef?.prepareChangesForSaving;
};

watch(isDirty, () => {
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, null, 'typetrans-view');
});

const onUserDataChanged = async args => {
    isDirty.value = true;
    setTabReadyToSaveValue(true);
    await saveUserDataChanges(args);
    tabState[window.location.pathname].changes = args.changes;
};

const onUserDataChangedLoaded = userData => {
    if (userData?.gridChanges?.length) {
        isDirty.value = true;
        setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, null, 'typetrans-view');
    }
};

const onRefreshHandler = async () => {
    isDirty.value = false;
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, null, 'typetrans-view');
    tabState[window.location.pathname] = null;
};

const onChangesRemoved = () => {
    isDirty.value = false;
    setIsDirtyValue(isDirty.value, saveFunc, prepareChanges, null, 'typetrans-view');
};

const onValueChange = async event => {
    importedRef.value = event.value;
    args.select.select_args.selectArg = event.value;

    await gridRef.value.setDataSource(false, event.value);
};
</script>
